var M = Object.defineProperty;
var u = (t, e, o) => e in t ? M(t, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : t[e] = o;
var l = (t, e, o) => (u(t, typeof e != "symbol" ? e + "" : e, o), o);
import { reactive as h, markRaw as k, inject as m, defineComponent as v, openBlock as c, createBlock as p, TransitionGroup as S, normalizeProps as f, guardReactiveProps as y, unref as r, withCtx as _, createElementBlock as g, Fragment as R, renderList as w, resolveDynamicComponent as x, mergeProps as j } from "vue";
const d = Symbol("modal-system");
class P {
  constructor(e) {
    l(this, "idTicker", 0);
    l(this, "modalStack", h([]));
    l(this, "resolveMap", /* @__PURE__ */ new Map());
    this.options = e;
  }
  closeModal(e, o) {
    var i;
    const n = this.modalStack.findIndex((s) => s.id === e);
    n >= 0 && (this.modalStack.splice(n, 1), (i = this.resolveMap.get(e)) == null || i[0](o), this.resolveMap.delete(e));
  }
  closeModalAsRejected(e, o) {
    var i;
    const n = this.modalStack.findIndex((s) => s.id === e);
    n >= 0 && (this.modalStack.splice(n, 1), (i = this.resolveMap.get(e)) == null || i[1](o), this.resolveMap.delete(e));
  }
  openModal(e, o) {
    const n = this.idTicker;
    return this.idTicker++, this.modalStack.push({
      id: n,
      props: o,
      component: k(e)
    }), new Promise((s, a) => {
      this.resolveMap.set(n, [s, a]);
    });
  }
}
function B() {
  const t = m(d);
  if (!t)
    throw new Error("No modal system provided");
  return {
    openModal: t.openModal.bind(t)
  };
}
const C = {
  install(t, e) {
    const o = new P(e);
    t.provide(d, o);
  }
}, D = /* @__PURE__ */ v({
  __name: "DialogHost",
  setup(t) {
    const e = m(d);
    return (o, n) => {
      var i;
      return c(), p(S, f(y(((i = r(e).options) == null ? void 0 : i.transition) ?? {})), {
        default: _(() => [
          (c(!0), g(R, null, w(r(e).modalStack, (s) => (c(), p(x(s.component), j({
            key: s.id
          }, s.props, {
            onModalResolve: (a) => r(e).closeModal(s.id, a),
            onModalReject: (a) => r(e).closeModalAsRejected(s.id, a)
          }), null, 16, ["onModalResolve", "onModalReject"]))), 128))
        ]),
        _: 1
      }, 16);
    };
  }
});
export {
  D as DialogHost,
  P as ModalSystem,
  d as ModalSystemSymbol,
  C as plugin,
  B as useModals
};
